import h from 'stringjsx';
import I18n from '@/modules/i18n';

export default class Comment {
  constructor({text, updated_at, updated_by}) {
    this.text = text;
    this.updated_at = updated_at;
    this.updated_by = updated_by;
  }

  render() {
    return (
      <div class="background-color_lightgrey fildset_frame">
        <p class="f-bold">
          {I18n.t(`balancereport.updated_at`)} {I18n.l(`time.formats.medium`, this.updated_at)} {I18n.t(`by`)} {this.updated_by.filtered_name}
        </p>
        <p> {this.text} </p>
      </div>
    );
  }
}
